import React from "react";

const Coffee = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            stroke={fill || "#4E525F"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.111}
            d="M4 21.111c1.291.999 3.23 1.582 5.445 1.556 2.213.026 4.153-.557 5.444-1.556 1.291-.998 3.231-1.582 5.445-1.555 2.213-.027 4.153.557 5.444 1.555M11.778 4a3.733 3.733 0 0 0-1.555 3.111 3.734 3.734 0 0 0 1.555 3.111M18 4a3.733 3.733 0 0 0-1.555 3.111 3.734 3.734 0 0 0 1.556 3.111"
        />
        <path
            stroke={fill || "#4E525F"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.111}
            d="M4 14.889h21.778v7.778A9.334 9.334 0 0 1 16.445 32h-3.111A9.333 9.333 0 0 1 4 22.667v-7.778Z"
        />
        <path
            stroke={fill || "#4E525F"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.111}
            d="M25.383 25.352a4.668 4.668 0 1 0 .392-8.642"
        />
    </svg>
);

export default Coffee;
